import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { RolesModels } from '../models/roles-models';


@Injectable({
  providedIn: 'root'
})
export class OpRolesService {

  constructor(private http: HttpClient) { }
  setHeader() {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return headers;
  }

  myHeaders = this.setHeader();

  getAllRoles() {
    let url = environment.URL + "/role/getall";
    return this.http.get(url, { headers: this.myHeaders });
  }

  roleRecordById(roleId) {
    const url = environment.URL + '/role/edit/' + roleId;
    return this.http.get(url, { headers: this.setHeader() });
  }

  saveRoles(bodyParams: RolesModels) {
    const url = environment.URL + '/role/create';
    return this.http.post(url, bodyParams, { headers: this.setHeader() });
  }

  updateRoles(bodyParams: RolesModels) {
    const url = environment.URL + '/role/update';
    return this.http.post(url, bodyParams, { headers: this.setHeader() });
  }

  deleteRoles(bodyParams: RolesModels) {
    const url = environment.URL + '/role/delete/' + bodyParams.id;
    return this.http.get(url, { headers: this.setHeader() });
  }

  tableSearch(value, column, pageId) {
    const url = environment.URL + '/role/' + value + '/' + column + '?page=' + pageId;
    return this.http.get(url, { headers: this.setHeader() });
  }
  retriveModulesList() {
    const url = environment.URL + '/module/getall';
    return this.http.get(url);
  }

}
